import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import { ExperienceResource } from '../CurrentCollectionStep/BuilderV2/Types';
import ExperienceVideoDetails from './ExperienceVideoDetails';

interface Props {
  className?: string;
  experienceResource: ExperienceResource;
  hideEnrollAction?: boolean;
}

function ExperienceVideoState({
  className,
  children,
  experienceResource,
  hideEnrollAction,
}: PropsWithChildren<Props>) {
  const thumbnail = experienceResource.links.find((l) => l.rel === 'thumbnail');
  if (thumbnail) {
    return (
      <ExperienceVideoDetails
        className={className}
        title={experienceResource.payload.title}
        thumbnail={thumbnail.href}
        experienceResource={experienceResource}
        hideEnrollAction={hideEnrollAction}
      />
    );
  }
  return <>{children}</>;
}

export default observer(ExperienceVideoState);
